import { createContext } from 'react';
import {
	IDataGetSubcategoryInfoV2,
	IItemForGetShortInfoWithStatus,
	IGetSubcategoryRestaurantProperties,
	TLanguageIDs,
} from 'types';

export type TTypeOfModalWindow = null | 'assignRestaurants' | 'errorUpdatingSubcategory' | 'assignDishes';

export interface IViewSubcategoryState {
	needRefetchData: boolean;
	needRefetchRestPropsData: boolean;
	subcategoryFullInfo: Nullable<IDataGetSubcategoryInfoV2>;
	accessibleRestaurants: IItemForGetShortInfoWithStatus[];
	restaurantIdForRestaurantProps: Nullable<string>;
	restaurantProps: Nullable<IGetSubcategoryRestaurantProperties['data']>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const viewSubcategoryInitialState: IViewSubcategoryState = {
	needRefetchData: false,
	needRefetchRestPropsData: false,
	subcategoryFullInfo: null,
	accessibleRestaurants: [],
	restaurantIdForRestaurantProps: null,
	restaurantProps: null,
	selectedTranslationTab: null,
	typeOfModalWindow: null,
};

export interface IViewSubcategoryContext extends IViewSubcategoryState {
	refetchData(value: boolean): void;
	refetchRestPropsData(value: boolean): void;
	setRestaurantIdForRestaurantProps(value: Nullable<string>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ViewSubcategoryContext = createContext<IViewSubcategoryContext>({
	refetchData: () => undefined,
	refetchRestPropsData: () => undefined,
	setRestaurantIdForRestaurantProps: () => undefined,
	setTranslationTab: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...viewSubcategoryInitialState,
});
